import { FeedbackShowResource, Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";

const previewKey = (feedbackId: Id) => ["feedbacks", `${feedbackId}`, "preview"];

export const feedbackPreviewService = {
	previewKey,
	getFeedbackPreview: (feedbackId: Id) =>
		axios.get<LaravelResponse<FeedbackShowResource>>(keyToUrl(previewKey(feedbackId))),
};
